import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { useSelector } from 'react-redux';

function FetEmbryoTable() {
  const borderRight = { borderRight: '1px solid rgba(224, 224, 224, 1)' };
  const { data } = useSelector((state) => state.dataAnalyticsReducer);
  const getCellData = (key, index) => {
    if (!data || !data[index] || !data[index].frozenDetails) {
      return 'N/A';
    }
    if (key === 'date') {
      return data[index].frozenDetails[key] === ''
        ? 'N/A'
        : new Date(data[index].frozenDetails[key]).toLocaleDateString('en-uk');
    }

    if (key === 'dayOfFET') {
      return data[index].frozenDetails.thawingDetails[0].thawingDetails === ''
        ? 'N/A'
        : data[index].frozenDetails.thawingDetails[0].thawingDetails;
    }

    if (key === 'gradeOfEmbryosTransfered') {
      const quality = ['N/A', 'N/A', 'N/A'];

      for (
        let i = 0;
        i < Math.min(data[index].frozenDetails.thawingDetails.length, 3);
        i++
      ) {
        if (
          data[index].frozenDetails.thawingDetails[i].fate === 'EMBRYO TRANSFER'
        ) {
          quality[i] =
            data[index].frozenDetails.thawingDetails[i].gradeAtFET === ''
              ? 'N/A'
              : data[index].frozenDetails.thawingDetails[i].gradeAtFET;
        }
      }

      return quality;
    }

    const frozenDetails = data[index].frozenDetails;
    if (frozenDetails[key] === null || frozenDetails[key] === '') {
      return 'N/A';
    }
    return frozenDetails[key] ?? 'N/A';
  };
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell
            colSpan={11}
            style={{
              fontWeight: 700,
              textAlign: 'center',
              ...borderRight,
            }}
          >
            EMBRYO TRANSFER DETAILS
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell style={{ fontWeight: 700 }}>
            {' '}
            <div
              style={{
                height: '60px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              Date of FET
            </div>
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>Day of FET</TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            No. of Embryos Transferred
          </TableCell>
          <TableCell colSpan={3} style={{ fontWeight: 700 }}>
            Grade Of Embryos Transferred
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            No. of Embryo Discarded
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            Transfer Details (Easy/Difficult){' '}
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            Endometrial Thickness (mm){' '}
          </TableCell>
          <TableCell style={{ fontWeight: 700 }}>
            Embryologist Performed FET{' '}
          </TableCell>
          <TableCell
            style={{
              fontWeight: 700,
              ...borderRight,
            }}
          >
            Clinician Performed FET
          </TableCell>
        </TableRow>

        {data &&
          data.map((_, index) => (
            <TableRow key={index}>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('date', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('dayOfFET', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('noOfEmbryoTransfered', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('gradeOfEmbryosTransfered', index)[0]}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('gradeOfEmbryosTransfered', index)[1]}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('gradeOfEmbryosTransfered', index)[2]}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('noOfEmbryoDiscarded', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('transferDetails', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('EndometrialThickness', index)}
                </div>
              </TableCell>
              <TableCell>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('embryologist', index)}
                </div>
              </TableCell>
              <TableCell style={borderRight}>
                <div
                  style={{
                    height: '60px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {getCellData('clinician', index)}
                </div>
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
}

export default FetEmbryoTable;
